import { getUserProfile } from '../services/userProfile';

const CMS_URL = import.meta.env.VITE_CMS_URL ?? 'https://doublebagel.co';

/** Returns the CMS URL for a coach's public profile page. */
export function cmsCoachProfileUrl(
  slug: string | undefined,
  coachId: string,
  uid?: string,
  /** Fragment to land on, without the leading '#'. e.g. 'offers'. */
  hash?: string,
): string {
  const path = slug ? `/coaches/${slug}` : `/coaches/${coachId}`;
  const query = uid ? `?uid=${uid}` : '';
  return `${CMS_URL}${path}${query}${hash ? `#${hash}` : ''}`;
}

/**
 * Navigates to a coach's public profile on the CMS.
 * Resolves the slug from Firestore when not already known.
 */
export async function goToCoachProfile(coachId: string, uid?: string, hash?: string): Promise<void> {
  try {
    const profile = await getUserProfile(coachId);
    const slug = profile?.coachProfile?.slug;
    window.location.href = cmsCoachProfileUrl(slug, coachId, uid, hash);
  } catch {
    window.location.href = cmsCoachProfileUrl(undefined, coachId, uid, hash);
  }
}
